// Table export helpers — JSONL / JSON / CSV downloads for result-table rows.
// Extracted from IpTableView's handleExport so both the classic ip table and
// the Selector Search tool rail share one implementation. Rows are plain
// objects of any shape: CSV flattens nested objects to dot-notation columns.

function download(content, filename, type) {
  const blob = new Blob([content], { type: type + ';charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)

  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  link.style.display = 'none'

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  URL.revokeObjectURL(url)
}

// Flatten an object to dot notation keys
function flattenObject(obj, prefix = '') {
  const result = {}
  for (const [key, value] of Object.entries(obj)) {
    const fullKey = prefix ? `${prefix}.${key}` : key
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      Object.assign(result, flattenObject(value, fullKey))
    } else {
      result[fullKey] = value
    }
  }
  return result
}

// Format value for CSV
function formatValue(value) {
  if (value === null || value === undefined) return ''
  if (Array.isArray(value)) {
    return value.map(v => (typeof v === 'object' ? JSON.stringify(v) : v)).join('; ')
  }
  return String(value)
}

// Escape CSV value
function escapeCSV(value) {
  let str = formatValue(value)
  // Neutralise CSV formula injection: prefix values starting with characters
  // that spreadsheet applications interpret as formulas (=, +, -, @, \t, |)
  // with [PROT]. Excel/Sheets treat the prefixed value as a plain text string.
  if (/^[=+\-@\t|]/.test(str)) {
    str = '[PROT]' + str
  }
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return '"' + str.replace(/"/g, '""') + '"'
  }
  return str
}

function toCSV(rows) {
  // Flatten all rows and collect all unique keys
  const flattenedRows = rows.map(row => flattenObject(row))
  const allKeys = new Set()
  for (const row of flattenedRows) {
    for (const key of Object.keys(row)) {
      allKeys.add(key)
    }
  }

  // Sort keys for consistent column order
  const sortedKeys = Array.from(allKeys).sort()

  let csv = sortedKeys.join(',') + '\n'
  for (const row of flattenedRows) {
    const values = sortedKeys.map(key => escapeCSV(row[key]))
    csv += values.join(',') + '\n'
  }
  return csv
}

export function useTableExport() {
  /**
   * Download `rows` in the given format.
   * @param {Array<Object>} rows plain row objects
   * @param {'jsonl'|'json'|'csv'} format
   * @param {string} baseName filename without extension
   */
  function exportRows(rows, format, baseName = 'results') {
    const data = rows || []

    if (format === 'jsonl') {
      let content = ''
      for (let i = 0; i < data.length; i++) {
        content += JSON.stringify(data[i]) + '\n'
      }
      download(content, `${baseName}.jsonl`, 'application/json')
    } else if (format === 'json') {
      download(JSON.stringify(data, null, 2), `${baseName}.json`, 'application/json')
    } else if (format === 'csv') {
      download(toCSV(data), `${baseName}.csv`, 'text/csv')
    }
  }

  return { exportRows }
}
